// extracted by mini-css-extract-plugin
export var blue = "_1q-g";
export var brand = "_1q-c";
export var darkGrey = "_1q-f";
export var disabled = "_1q-6";
export var disabledSubtle = "_1q-7";
export var error = "_1q-8";
export var green = "_1q-h";
export var grey = "_1q-e";
export var icon = "_1q-0";
export var inherit = "_1q-b";
export var lightGrey = "_1q-d";
export var orange = "_1q-j";
export var pink = "_1q-l";
export var primary = "_1q-1";
export var purple = "_1q-m";
export var quaternary = "_1q-4";
export var quinary = "_1q-5";
export var red = "_1q-k";
export var secondary = "_1q-2";
export var success = "_1q-a";
export var tertiary = "_1q-3";
export var warning = "_1q-9";
export var white = "_1q-n";
export var yellow = "_1q-i";